// import React, { useState } from "react";
// import TemplateApi from "../../api/TemplateApi";
// import { showSuccess, showError } from "../../utils/toastUtils";
// import Auth from "../../utils/AuthUtils";

// function AddDetails({ refresh }) {
//   const [form, setForm] = useState({
//     templateName: "",
//     templateType: "",
//     url: "",
//     variantType: "",
//     description: "",
//   });

//   const [loading, setLoading] = useState(false);

//   const normalizeUrl = (url) => {
//     if (!url.startsWith("http://") && !url.startsWith("https://")) {
//       return `https://${url}`;
//     }
//     return url;
//   };

//   const handleChange = (e) => {
//     setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       !form.templateName ||
//       !form.templateType ||
//       !form.url ||
//       !form.variantType
//     ) {
//       return showError("All required fields must be filled");
//     }

//     const payload = {
//       ...form,
//       url: normalizeUrl(form.url), // ✅ FIX APPLIED HERE
//       uploadedBy: Auth.getUserDetails("id"), // backend requirement
//     };

//     try {
//       setLoading(true);
//       const res = await TemplateApi.add(payload);

//       if (res.code === 200) {
//         showSuccess(res.message);
//         refresh?.();
//         document
//           .querySelector("#add-template-modal .btn-close")
//           ?.click();
//       } else {
//         showError(res.message);
//       }
//     } catch (err) {
//       console.error(err);
//       showError("Failed to add template");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="modal fade" id="add-template-modal" tabIndex={-1}>
//       <div className="modal-dialog modal-md">
//         <div className="modal-content">
//           <div className="modal-header">
//             <h5>Add Template</h5>
//             <button className="btn-close" data-bs-dismiss="modal" />
//           </div>

//           <form onSubmit={handleSubmit}>
//             <div className="modal-body">
//               {["templateName", "templateType", "url", "variantType"].map(
//                 (f) => (
//                   <div className="mb-3" key={f}>
//                     <label className="form-label">{f}</label>
//                     <input
//                       name={f}
//                       className="form-control"
//                       value={form[f]}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 )
//               )}

//               <div className="mb-3">
//                 <label>Description</label>
//                 <textarea
//                   name="description"
//                   className="form-control"
//                   rows={3}
//                   value={form.description}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 data-bs-dismiss="modal"
//                 disabled={loading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={loading}
//               >
//                 {loading ? "Saving..." : "Save"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddDetails;


import React, { useState } from "react";
import TemplateApi from "../../api/TemplateApi";
import { showSuccess, showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";

function AddDetails({ refresh }) {
  const [form, setForm] = useState({
    templateName: "",
    templateType: "",
    url: "",
    variantType: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form, uploadedBy: Auth.getUserDetails("id") };

    try {
      setLoading(true);
      const res = await TemplateApi.add(payload);
      if (res.code === 200) {
        showSuccess(res.message);
        setForm({ templateName: "", templateType: "", url: "", variantType: "", description: "" });
        refresh?.();
        document.querySelector("#add-template-modal .btn-close")?.click();
      }
    } catch (err) {
      showError("Failed to add template");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal fade" id="add-template-modal" tabIndex={-1}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header"><h5>Add Template</h5><button className="btn-close" data-bs-dismiss="modal" /></div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              {["templateName", "templateType", "url", "variantType"].map((f) => (
                <div className="mb-3" key={f}>
                  <label className="form-label">{f}</label>
                  <input name={f} className="form-control" value={form[f]} onChange={handleChange} required />
                </div>
              ))}
              <div className="mb-3">
                <label>Description</label>
                <textarea name="description" className="form-control" rows={3} value={form.description} onChange={handleChange} />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="submit" className="btn btn-primary" disabled={loading}>{loading ? "Saving..." : "Save"}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddDetails;